export default {
    photographers: [],
    regions: [],
    photographersByRegion: [],
    smsTemplatesForPhotographer: [],
    lastFetch: {},
    emailTemplatesForPhotographer: [],
    emailSendersForPhotographer: []
};
